import type { Components } from '@mui/material/styles';
import { type Theme } from '@mui/material/styles';

export const chipTheme: Pick<Components<Theme>, 'MuiChip'> = {
  MuiChip: {
    defaultProps: {
      size: 'small',
    },
    styleOverrides: {
      root: {
        variants: [
          {
            props: { size: 'medium' },
            style: {
              '.svg-inline--fa': {
                fontSize: '1.25em',
              },
            },
          },
          {
            props: { size: 'small' },
            style: {
              '.svg-inline--fa': {
                fontSize: '1em',
              },
            },
          },
        ],
      },
    },
  },
};
